export default __webpack_public_path__ + "static/media/icon.2817d64a.svg";